import { type RefreshTokenCallback } from '../../http/refresh/RefreshTokenCallback.ts';
import { AuthSubject } from '../../state/AuthSubject.tsx';
import { OpenIDConnectStrategyCode } from './OpenIDConnectConstants.tsx';

/**
 * Effettua il refresh del token tramite OpenID Connect.
 * In questo caso non viene effettuata una chiamata al backend direttamente,
 * ma viene utilizzato il refresh token di OpenID Connect per ottenere un nuovo
 * access token, che a sua volta viene inviato al backend per ottenere un nuovo
 * JWT applicativo.
 */
export const refreshOpenIDConnectToken: RefreshTokenCallback = async (
  store,
  authState,
) => {
  return new Promise((resolve, reject) => {
    AuthSubject.next({
      type: 'refresh',
      strategy: OpenIDConnectStrategyCode,
      authState,
      resolve,
      reject,
    });
  });
};
